import type { CalloutComponent } from "../../types";
import { GuardedLink } from "../../runtime/DevPlaceholder";

/** Call-to-action callout renderer with title and link. The block always renders;
 *  a non-connected link opens the dev modal in preview and disappears in production. */
export function CalloutRenderer({ component }: { component: CalloutComponent }) {
  const { title, linkHref, linkLabel } = component.content;
  return (
    <section className="rounded-md bg-[#eaf2fb] p-4 md:p-5">
      <h2 className="text-[#005CA9] font-semibold">{title}</h2>
      {linkLabel ? (
        <GuardedLink href={linkHref} label={linkLabel} className="mt-2 inline-flex items-center gap-2 text-[#0095DB] hover:underline text-sm xl:text-base">
          {linkLabel} <span aria-hidden>›</span>
        </GuardedLink>
      ) : null}
    </section>
  );
}


